import React, { useState, useEffect } from "react";
import { ServiceApi } from "../services/index.service";
import EditIcon from "@mui/icons-material/Edit";
// import { useSelector } from "react-redux";
import Slide from "@mui/material/Slide";
import {
  Backdrop,
  Button,
  Chip,
  CircularProgress,
  DialogActions,
  Divider,
  Fab,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FlavorTabShimmer from "./FlavorTabShimmer";
import { useSnackbar } from "notistack";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckIcon from "@mui/icons-material/Check";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import AWS from "aws-sdk";
import RecipeCardPreview from "./RecipeCardPreview";
import { DeleteOutlineSharp, PreviewRounded } from "@mui/icons-material";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const styles = {
  closeMark: {
    border: "none",
    display: "inline-block",
    padding: "8px 16px",
    verticalAlign: "middle",
    overflow: "hidden",
    textDecoration: "none",
    color: "inherit",
    backgroundColor: "inherit",
    textAlign: "center",
    cursor: "pointer",
    whiteSpace: "nowrap",
  },

  topright: {
    position: "absolute",
    right: 0,
    top: 0,
  },
};

AWS.config.update({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
  region: process.env.REACT_APP_AWS_REGION,
});

const FlavorDrivenTreats = () => {
  const s3 = new AWS.S3();
  const { enqueueSnackbar } = useSnackbar();
  // const { storage } = useSelector((state) => state);
  const imageInputRef = React.useRef();
  const [image, setImage] = useState("");
  const [imageurl, setImageurl] = useState("");
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = React.useState(false);
  // const [next, setNext] = useState(flavorsPerRow);
  // const handleMoreFlavors = () => {
  //   setNext(next + flavorsPerRow);
  // };
  const [flavorLoading, setFlavorLoading] = useState(true);
  //handle stores
  // const [query, setQuery] = useState("");
  // const [store, setStore] = useState(null);
  const [updateFlavorId, setUpdateFlavorId] = useState("");
  const [onFileSelectError, setOnFileSelectError] = useState("");
  // const [storeList, setStoreList] = useState([]);
  // const [isSDLoading, setIsSDLoading] = useState(false);
  //handle flavors
  const [selectedNames, setSelectedNames] = useState([]);
  const [selectObject, setSelectObject] = useState([]);
  const [action, setAction] = React.useState("");
  const [flavors, setFlavors] = React.useState(null);
  const [flavorsList, setFlavorsList] = React.useState([]);
  const [flavorTreatsList, setFlavorTreatsList] = React.useState([]);
  const [file, setFile] = React.useState("");
  const [flavorDrivenProducts, setFlavorDrivenProducts] = useState([]);
  const [selectFlavor, setselectFlavor] = React.useState([]);
  const [productType, setProductType] = useState("");
  const [flavorproductType, setFlavorproductType] = useState("");
  const [flavorName, setFlavorName] = useState("");
  const [receiptName, setReceiptName] = useState("");
  const [activeStatus, setActiveStatus] = useState(false);
  // const [s3Uri, setS3Uri] = useState("");
  const [flavorID, setFlavorID] = useState("");
  // error handling
  const [showSelect, setShowSelect] = React.useState(false);
  const [isSelected, setIsSelected] = useState("");
  const [isItemsFilled, setIsItemsFilled] = useState("");
  const [isReceiptFilled, setIsReceiptFilled] = useState("");

  const [showRecipeCards, setShowRecipeCards] = useState(false);
  const [selectedFlavor, setSelectedFlavor] = useState(null);
  const [onRecipeFileSelectError, setOnRecipeFileSelectError] = useState({
    quarterContainer: "",
    halfContainer: "",
    singleContainer: "",
    doubleContainer: "",
  });
  const initialRecipe = {
    quarterContainer: "",
    halfContainer: "",
    singleContainer: "",
    doubleContainer: "",
  };
  const [recipeImage, setRecipeImage] = useState(initialRecipe);
  const serviceapi = new ServiceApi();

  useEffect(() => {
    fetchFlavorDrivenTreats();
    getFlavors();
    getflavordrivenproducts();
    setOpen(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchFlavorDrivenTreats = async () => {
    try {
      setFlavorLoading(true);
      const result = await serviceapi?.fetchFlavorDrivenTreats();
      setFlavorTreatsList(result);
      getFlavors(result[0]?.flavor_data);
      if (result) {
        // setTimeout(() => {
        setFlavorLoading(false);
        // }, 900);
      }
    } catch (e) {
      setFlavorLoading(false);
      console.log(e);
    }
  };

  const getflavordrivenproducts = async () => {
    try {
      // setFlavorLoading(true);
      const result = await serviceapi?.fetchFlavorDrivenProducts();
      // console.log(result, " ---- response in flavor driven products");
      setFlavorDrivenProducts(result);
      // if (result) {
      //   setFlavorLoading(false);
      // }
    } catch (e) {
      // setFlavorLoading(false);
      console.log(e);
    }
  };

  const getSignedUrl = (file) => {
    const imgPath = file.split("/");
    // console.log(imgPath, "split");
    // console.log(file);
    const iParams = {
      Bucket: process.env.REACT_APP_AWS_BUCKET,
      Key: `${imgPath[3]}/${imgPath[4]}`,
    };
    var url = s3.getSignedUrl("getObject", iParams);
    // console.log(url, "signed url");
    return url;
  };

  const getFlavors = (res) => {
    try {
      // setFlavorLoading(true);

      const response = res; // await serviceapi?.fetchManageFlavors();
      // console.log(response, " ---- response in manage floors");
      const uniqueTags = [];
      response.map((item) => {
        var i = uniqueTags.findIndex(
          (x) => x.intProductTypeID === item.intProductTypeID
        );
        if (i <= -1) {
          uniqueTags.push(item);
        }
        return null;
      });
      let cat = [...new Set(response)];
      // console.log(cat, "..........cat");
      // console.log(uniqueTags, "::: uTags");
      setselectFlavor(uniqueTags);
      setFlavors(response);
      setFlavorsList(response);
      // setFlavorLoading(false);
    } catch (e) {
      // setFlavorLoading(false);
      console.log(e);
    }
  };
  const callActions = (action, obj) => {
    setAction(action);
    setIsItemsFilled("");
    setIsReceiptFilled("");
    setIsSelected("");
    setImage("");
    setFile("");
    setImageurl("");
    setReceiptName("");
    setActiveStatus(false);
    setUpdateFlavorId("");
    if (action.trim() === "Add") {
      setLoading(true);
      setImageurl("");
      setSelectedNames([]);
      setProductType("");
      setFlavorproductType("");
      setLoading(false);
    }
    if (action.trim() === "Edit") {
      setLoading(true);
      let arrayList = [];
      setActiveStatus(obj.active);
      setUpdateFlavorId(obj.flavor_driven_treat_id);
      setReceiptName(obj.flavor_driven_treat_name);
      setImageurl(obj.image_url);
      if (obj.image_url) {
        setImage(getSignedUrl(obj.image_url));
      }
      flavorTreatsList[0]?.flavor_data?.map((flavor) => {
        obj?.flavor_driven_components?.split(",").some((ele) => {
          if (parseInt(ele) === flavor?.fid) {
            obj?.receipt_names?.split(",").some((recip) => {
              if (recip.toLowerCase() === flavor?.receiptName.toLowerCase()) {
                arrayList.push(flavor);
              }
            });
          }
        });
      });

      setFlavorproductType(obj.product_type_id);
      setTimeout(() => {
        setSelectedNames(arrayList);
        setLoading(false);
      }, 900);
    }

    setOpen(true);
  };

  const handleClose = (event, reason) => {
    // setOpen(false);
    if (reason && reason === "backdropClick") return;
    myCloseModal();
  };
  const myCloseModal = () => {
    setSelectedNames([]);
    setProductType("");
    setFlavorproductType("");
    setIsItemsFilled("");
    setIsReceiptFilled("");
    setIsSelected("");
    setReceiptName("");
    setOpen(false);
  };

  const flavorActiveChange = (e, active, id) => {
    setActiveStatus(e.target.checked);
  };

  const onSubmit = (e) => {
    // console.log(selectedNames);
    let itms = [];
    e.preventDefault();
    selectedNames?.map((itm) => {
      itms.push(itm.fid);
    });

    if (!receiptName) {
      setIsReceiptFilled("Please enter flavor driven treat");
    } else {
      setIsReceiptFilled("");
    }
    if (!flavorproductType) {
      setIsSelected("Please select flavor category");
    } else {
      setIsSelected("");
    }
    if (itms.length === 0) {
      setIsItemsFilled("Please select treat flavors");
    } else {
      setIsItemsFilled("");
    }

    let flavorObj = {};

    if (flavorproductType && receiptName && itms.length > 0) {
      if (action.trim() === "Edit") {
        flavorObj = {
          action: "edit",
          vchFlavorDrivenTreatName: receiptName,
          intProductTypeID: flavorproductType,
          vchFlavorDrivenComponents: itms.join(","),
          intFlavorDrivenTreatID: updateFlavorId,
          image_url: imageurl ? imageurl : "",
          image: file,
          bitActive: activeStatus === true ? true : false,
        };
      } else {
        flavorObj = {
          action: "add",
          vchFlavorDrivenTreatName: receiptName,
          intProductTypeID: flavorproductType,
          vchFlavorDrivenComponents: itms.join(","),
          image: file,
          bitActive: activeStatus === true ? true : false,
        };
      }
      callCRUDAction(flavorObj);
    } else {
      return;
    }
  };
  const callCRUDAction = async (Obj) => {
    setLoading(true);
    const result = await serviceapi?.addFlavrDrivenTreats(Obj);
    // console.log(result, "::: result");
    if (result?.statusCode === 200) {
      enqueueSnackbar(result.message, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "success",
      });
      setLoading(false);
      setOpen(false);
      fetchFlavorDrivenTreats();
    } else if (result?.statusCode === 201) {
      enqueueSnackbar(result.message, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "success",
      });
      setLoading(false);
      setOpen(false);
      fetchFlavorDrivenTreats();
    } else if (result?.statusCode === 400) {
      enqueueSnackbar(result.message, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
      });
      setLoading(false);
    } else {
      enqueueSnackbar(result.message, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
      });
      setLoading(false);
    }
  };
  const selectFlavorDriven = (e) => {
    // console.log(e.target.value, " elsdlfsdj", e);
    let newObject = e.target.value;
    setIsItemsFilled("");
    setSelectedNames(newObject);
  };

  const handleFileChange = (e) => {
    // e.preventDefault();
    if (!e.target.files) return;

    const file = e.target.files[0];

    setOnFileSelectError("");

    let fileSize = file?.size;
    fileSize = fileSize / 1048576;
    if (fileSize > 2) {
      setOnFileSelectError({ error: "File size cannot exceed more than 1MB" });
    } else {
      setImage(URL.createObjectURL(file));
      const reader = new FileReader();
      reader.onloadend = () => {
        const imageData = reader.result;
        setFile(imageData);
        // console.log(imageData, "imageDATA");
      };
      reader.readAsDataURL(file);
    }
  };

  const clearImageRefs = (e) => {
    setImage("");
    imageInputRef.current.value = "";
  };

  const handleCloseRecipeCards = () => {
    setShowRecipeCards(!showRecipeCards);
  };
  const handleRecipeCard = (dataItem) => {
    setShowRecipeCards(!showRecipeCards);
    const flavorItem = {
      ...dataItem,
      quarterContainer:
        dataItem?.quarterContainer === ""
          ? dataItem?.quarterContainer
          : getSignedUrl(dataItem?.quarterContainer),
      halfContainer:
        dataItem?.halfContainer === ""
          ? dataItem?.halfContainer
          : getSignedUrl(dataItem?.halfContainer),
      singleContainer:
        dataItem?.singleContainer === ""
          ? dataItem?.singleContainer
          : getSignedUrl(dataItem?.singleContainer),
      doubleContainer:
        dataItem?.doubleContainer === ""
          ? dataItem?.doubleContainer
          : getSignedUrl(dataItem?.doubleContainer),
    };
    setSelectedFlavor(flavorItem);
  };
  const handleRecipeFileChange = (e, name) => {
    console.log(e, name);
    // e.preventDefault();
    if (!e.target.files) return;

    const file = e.target.files[0];
    setOnRecipeFileSelectError({ ...onRecipeFileSelectError, [name]: "" });
    // if (action === "Edit") {
    //   setIsUpdImageChanged(true);
    // }
    let fileSize = file?.size;
    fileSize = fileSize / 1048576;
    console.log(file);
    if (fileSize > 2) {
      setOnFileSelectError({ error: "File size cannot exceed more than 1MB" });
    } else {
      const reader = new FileReader();
      reader.onloadend = () => {
        const imageData = reader.result;
        setRecipeImage({ ...recipeImage, [name]: imageData });
        // console.log(imageData, "imageDATA");
      };
      reader.readAsDataURL(file);
    }
  };

  const handleClearRecipeImages = (name) => {
    setRecipeImage({ ...recipeImage, [name]: "" });
  };

  return (
    <>
      {showRecipeCards && (
        <RecipeCardPreview
          showRecipeCards={showRecipeCards}
          selectedFlavor={selectedFlavor}
          handleCloseRecipeCards={handleCloseRecipeCards}
        />
      )}
      <Dialog
        maxWidth="sm"
        fullWidth="false"
        TransitionComponent={Transition}
        sx={{ zIndex: 1000 }}
        PaperProps={{
          style: {
            minWidth: "37%",
            maxWidth: "47%",
            minHeight: "50%",
            maxHeight: "60%",
          },
        }}
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>{action} Treat</DialogTitle>
        <Divider />
        <DialogContent>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
            onClick={handleClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={12} sm={12} md={6}>
              <FormControl sx={{ m: 1, minWidth: "95%" }}>
                <TextField
                  size="small"
                  label="Flavor Driven Treat Name"
                  variant="outlined"
                  required
                  error={isReceiptFilled ? true : ""}
                  value={receiptName}
                  onChange={(e) => {
                    setReceiptName(e.target.value);
                    setIsReceiptFilled("");
                  }}
                />
                <div style={{ color: "red" }}>
                  {isReceiptFilled && (
                    <FormHelperText>{isReceiptFilled}</FormHelperText>
                  )}
                </div>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <FormControl sx={{ m: 1, minWidth: "95%" }}>
                <InputLabel id="product-type" required size="small">
                  Category
                </InputLabel>
                <Select
                  variant="outlined"
                  size="small"
                  labelId="product-type"
                  id="product-type-modal"
                  error={isSelected ? true : ""}
                  label="flavorproducttypes"
                  value={flavorproductType}
                  onChange={(e) => {
                    setFlavorproductType(e.target.value);
                  }}
                >
                  {flavorDrivenProducts?.data?.map((product) => (
                    <MenuItem value={product?.intProductTypeID}>
                      {product?.vchProductTypeName}
                    </MenuItem>
                  ))}
                </Select>
                <div style={{ color: "red" }}>
                  {isSelected && <FormHelperText>{isSelected}</FormHelperText>}
                </div>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <FormControl sx={{ m: 1, minWidth: "95%" }}>
                <InputLabel id="flavor-label" size="small">
                  Flavor Type
                </InputLabel>
                <Select
                  variant="outlined"
                  size="small"
                  labelId="flavor-label"
                  id="flavor-label-modal"
                  label="producttypes"
                  value={productType}
                  onChange={(e) => {
                    setProductType(e.target.value);
                    setIsSelected("");
                  }}
                >
                  {selectFlavor?.map((name) => (
                    <MenuItem value={name}>{name?.product_type_name} </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={12} md={6}>
              <FormControl sx={{ m: 1, minWidth: "95%" }}>
                <FormControlLabel
                  sx={{ pl: 2 }}
                  control={
                    <Switch
                      checked={activeStatus}
                      onChange={(e) => flavorActiveChange(e)}
                      name="active"
                      label="Active"
                    />
                  }
                  label="Active"
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              {selectedNames?.map((value) => (
                <Chip
                  style={{ margin: "5px 8px" }}
                  key={value.fid}
                  label={value.receiptName}
                  onDelete={() =>
                    setSelectedNames(
                      selectedNames.filter((item) => item.fid !== value.fid)
                    )
                  }
                  deleteIcon={
                    <CancelIcon
                      onMouseDown={(event) => event.stopPropagation()}
                    />
                  }
                />
              ))}
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl sx={{ m: 1, width: "98%" }}>
                <InputLabel id="flavor-items" required size="small">
                  {productType ? productType.product_type_name : "Flavors"}
                </InputLabel>
                <Select
                  size="small"
                  multiple
                  open={showSelect}
                  labelId="flavor-items"
                  error={isItemsFilled ? true : ""}
                  value={selectedNames}
                  onChange={selectFlavorDriven}
                  onOpen={() => setShowSelect(true)}
                  onClose={() => setShowSelect(false)}
                  input={
                    <OutlinedInput
                      label="Multiple Select"
                      style={{ paddingTop: 0 }}
                    />
                  }
                >
                  {showSelect && productType && (
                    <>
                      <span
                        style={{
                          position: "sticky",
                          zIndex: 300,
                          display: "inherit",
                          height: "30px",
                        }}
                      >
                        <Fab
                          onClick={() => {
                            setShowSelect(false);
                          }}
                          variant="extended"
                          size="small"
                          style={{
                            width: "72px",
                            height: "26px",
                            float: "right",
                            cursor: "pointer",
                            backgroundColor: "#D41042",
                          }}
                          color="secondary"
                        >
                          ADD
                        </Fab>
                      </span>
                      <Divider />
                    </>
                  )}
                  {flavorsList
                    ?.filter(
                      (flv) =>
                        flv.intProductTypeID === productType.intProductTypeID
                    )
                    .map((flvor, ind) => (
                      <MenuItem
                        key={flvor?.intFlavorID}
                        value={flvor}
                        id={ind}
                        name={ind}
                        sx={{ justifyContent: "space-between" }}
                      >
                        {flvor?.flavor_name}
                        {selectedNames?.some(
                          (ele) => ele.fid === flvor?.fid
                        ) ? (
                          <CheckIcon color="info" />
                        ) : null}
                      </MenuItem>
                    ))}
                </Select>
                <div style={{ color: "red" }}>
                  {isItemsFilled && (
                    <FormHelperText>{isItemsFilled}</FormHelperText>
                  )}
                </div>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <FormControl sx={{ m: 1, minWidth: "95%" }}>
                <label htmlFor="upload-photo">
                  <input
                    style={{ display: "none" }}
                    id="upload-photo"
                    name="upload-photo"
                    type="file"
                    accept="image/*"
                    onClick={clearImageRefs}
                    ref={imageInputRef}
                    onChange={handleFileChange}
                  />

                  <Button
                    color="secondary"
                    style={{ backgroundColor: "#D41042" }}
                    variant="contained"
                    component="span"
                  >
                    Upload Treat Icon <FileUploadIcon />
                  </Button>
                </label>
                {onFileSelectError && (
                  <FormHelperText>{onFileSelectError}</FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <div
                style={{
                  marginLeft: "10px",
                  color: "#000000",
                  fontSize: "11px",
                  letterSpacing: "0.00938em",
                }}
              >
                {image && (
                  <img
                    width="40px"
                    height="40px"
                    src={image}
                    alt="The current file"
                  />
                )}

              </div>
            </Grid>
          </Grid>
          {/* <hr />
          <TableContainer component={Paper} className="pt-2">
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Recipe Card</TableCell>
                  <TableCell>Upload</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {"QC"}
                  </TableCell>
                  <TableCell>
                    {recipeImage?.quarterContainer ? (
                      <>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div>
                            <img
                              width="40px"
                              height="40px"
                              src={recipeImage?.quarterContainer}
                              alt="The current file"
                            />
                          </div>
                          <div>
                            <DeleteOutlineSharp
                              color="error"
                              onClick={() =>
                                handleClearRecipeImages("quarterContainer")
                              }
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      <FormControl sx={{ m: 1, minWidth: "95%" }}>
                        <label htmlFor="qc-upload-photo">
                          <input
                            style={{ display: "none" }}
                            id="qc-upload-photo"
                            name="qc-upload-photo"
                            type="file"
                            accept="image/png, image/jpg, image/jpeg"
                            onChange={(e) =>
                              handleRecipeFileChange(e, "quarterContainer")
                            }
                          />
                          <FileUploadIcon color="info" />
                        </label>{" "}
                      </FormControl>
                    )}
                  </TableCell>
                </TableRow>
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {"HC"}
                  </TableCell>
                  <TableCell>
                    {recipeImage?.halfContainer ? (
                      <>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div>
                            <img
                              width="40px"
                              height="40px"
                              src={recipeImage?.halfContainer}
                              alt="The current file"
                            />
                          </div>
                          <div>
                            <DeleteOutlineSharp
                              color="error"
                              onClick={() =>
                                handleClearRecipeImages("halfContainer")
                              }
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      <FormControl sx={{ m: 1, minWidth: "95%" }}>
                        <label htmlFor="hc-upload-photo">
                          <input
                            style={{ display: "none" }}
                            id="hc-upload-photo"
                            name="hc-upload-photo"
                            type="file"
                            accept="image/png, image/jpg, image/jpeg"
                          
                            onChange={(e) =>
                              handleRecipeFileChange(e, "halfContainer")
                            }
                          />
                          <FileUploadIcon color="info" />
                        </label>{" "}
                       
                      </FormControl>
                    )}
                  </TableCell>
                </TableRow>
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {"SC"}
                  </TableCell>
                  <TableCell>
                    {recipeImage?.singleContainer ? (
                      <>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div>
                            <img
                              width="40px"
                              height="40px"
                              src={recipeImage?.singleContainer}
                              alt="The current file"
                            />
                          </div>
                          <div>
                            <DeleteOutlineSharp
                              color="error"
                              onClick={() =>
                                handleClearRecipeImages("singleContainer")
                              }
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      <FormControl sx={{ m: 1, minWidth: "95%" }}>
                        <label htmlFor="sc-upload-photo">
                          <input
                            style={{ display: "none" }}
                            id="sc-upload-photo"
                            name="sc-upload-photo"
                            type="file"
                            accept="image/png, image/jpg, image/jpeg"
                          
                            onChange={(e) =>
                              handleRecipeFileChange(e, "singleContainer")
                            }
                          />
                          <FileUploadIcon color="info" />
                        </label>{" "}
                      
                      </FormControl>
                    )}
                  </TableCell>
                </TableRow>
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {"DC"}
                  </TableCell>
                  <TableCell>
                    {recipeImage?.doubleContainer ? (
                      <>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div>
                            <img
                              width="40px"
                              height="40px"
                              src={recipeImage?.doubleContainer}
                              alt="The current file"
                            />
                          </div>
                          <div>
                            <DeleteOutlineSharp
                              color="error"
                              onClick={() =>
                                handleClearRecipeImages("doubleContainer")
                              }
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      <FormControl sx={{ m: 1, minWidth: "95%" }}>
                        <label htmlFor="dc-upload-photo">
                          <input
                            style={{ display: "none" }}
                            id="dc-upload-photo"
                            name="dc-upload-photo"
                            type="file"
                            accept="image/png, image/jpg, image/jpeg"
                          
                            onChange={(e) =>
                              handleRecipeFileChange(e, "doubleContainer")
                            }
                          />
                          <FileUploadIcon color="info" />
                        </label>{" "}
                       
                      </FormControl>
                    )}
                  </TableCell>
                 
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer> */}
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button onClick={myCloseModal}>Close</Button>
          {action === "Add" && <Button onClick={onSubmit}>Add</Button>}
          {action === "Edit" && <Button onClick={onSubmit}>Update</Button>}
        </DialogActions>
      </Dialog>
      <div className="py-6 mt-16">
        <header>
          <div className="flex justify-between items-center mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <h1 className="text-2xl font-display font-medium leading-tight text-secondary">
              Flavor Driven Treat Admin
            </h1>
            <div className="flex justify-end">
              <button
                type="button"
                onClick={() => callActions("Add", "")}
                className="inline-flex items-center justify-center rounded-md border border-transparent bg-primary px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-primary-light focus:ring-offset-2 sm:w-auto"
              >
                Add Treat
              </button>
            </div>
          </div>
        </header>
        <main>
          <div className="mx-auto max-w-7xl sm:px-6 lg:px-8">
            <div className="px-4 py-8 sm:px-0">
              {flavorLoading ? (
                <div className="bg-white grid grid-cols-3 lg:grid-cols-1 gap-4 p-4">
                  <FlavorTabShimmer />
                  <FlavorTabShimmer />
                  <FlavorTabShimmer />
                  <FlavorTabShimmer />
                  <FlavorTabShimmer />
                  <FlavorTabShimmer />
                </div>
              ) : (
                <div className="rounded-md bg-white shadow-md">
                  <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="inline-block min-w-full align-middle md:px-6 lg:px-8">
                      <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                        <table className="min-w-full divide-y divide-gray-300">
                          <thead className="bg-gray-50">
                            <tr>
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color sm:pl-6"
                              >
                                Treat ID
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color"
                              >
                                Treat Name
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color"
                              >
                                Category
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color"
                              >
                                Treats
                              </th>
                              {/* <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color"
                              >
                                Recipe Cards
                              </th> */}
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color"
                              >
                                Status
                              </th>

                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color "
                              >
                                Action
                              </th>
                            </tr>
                          </thead>
                          {/* {flavorsList?.map((section, flvIndex) => {
                          return ( */}
                          <tbody className="divide-y divide-gray-200 bg-white">
                            {/* {JSON.stringify(
                              flavorTreatsList[0].flavor_driven_data
                            )} */}

                            {flavorTreatsList[0]?.flavor_driven_data?.map(
                              (flvor, ind) => {
                                return (
                                  <tr key={flvor.flavor_key}>
                                    <td className="whitespace-nowrap px-3 py-1 text-sm text-gray-500 sm:pl-6">
                                      <div className="text-gray-700">
                                        {flvor?.flavor_driven_treat_id}
                                      </div>
                                    </td>

                                    <td
                                      className="whitespace-nowrap py-1 text-sm text-gray-500 px-3 "
                                      title={flvor?.flavor_driven_treat_name}
                                    >
                                      <div className="text-gray-700">
                                        {flvor?.flavor_driven_treat_name}
                                      </div>
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
                                      <div className="text-gray-700">
                                        {flvor?.product_type_name}
                                      </div>
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
                                      <div className="text-gray-700">
                                        <table>
                                          {flvor?.receipt_names
                                            ?.split(",")
                                            .map((ele) => {
                                              return (
                                                <tr>
                                                  <td>{ele}</td>
                                                </tr>
                                              );
                                            })}{" "}
                                        </table>
                                      </div>
                                    </td>
                                    {/* <td className="relative whitespace-nowrap py-1 pl-3 pr-4 text-right text-sm font-medium sm:pr-7">
                                      <span
                                        style={{ cursor: "pointer" }}
                                        variant="contained"
                                        onClick={() => handleRecipeCard(flvor)}
                                        className="text-primary hover:text-primary-dark flex-justify-center"
                                      >
                                        <PreviewRounded />
                                      </span>
                                    </td> */}
                                    <td className="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
                                      <div className="text-gray-700">
                                        {flvor?.active === true
                                          ? "Active"
                                          : "Inactive"}
                                      </div>
                                    </td>
                                    <td className="relative whitespace-nowrap px-3 pl-3 py-1 text-sm text-gray-500  font-medium ">
                                      <a
                                        onClick={() =>
                                          callActions("Edit", flvor)
                                        }
                                        className="text-primary hover:text-primary-dark"
                                      >
                                        <EditIcon />
                                      </a>
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </tbody>
                          {/*  );  })} */}
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default FlavorDrivenTreats;
